import { SupportedLanDataType } from '~/training/state/settings/createSupportedLanguages';
import { t } from 'ttag';

export const getSupportedLanguageLabel = (
  lan: string,
  supportedData: SupportedLanDataType
): string => {
  if (!supportedData) {
    return '';
  }

  const parts: string[] = [];

  if (supportedData.mediumLocales) {
    parts.push(t`Audio narration`);
  }

  if (supportedData.textLocales) {
    parts.push(t`Interface`);
  }

  if (supportedData.subtitleLocales) {
    parts.push(t`Captions`);
  }

  return parts.join(', ');
};
